import React, { useState, useEffect } from 'react';
import s from './Slider.module.scss';

import slide1 from '../assets/carousel1.png';
import slide2 from '../assets/carousel2.png';
import { ReactComponent as Logo } from '../assets/logo.svg';
import Flex from 'components/Flex';

const slides = [
  {
    id: 1,
    image: slide1,
    quote:
      'The partnership with GamesBoost42 not only enabled us to increase user engagement volumes in a targeted manner, but also helped maintain the advertising budget at the desired level.',
    author: 'Pavel Maurus',
    position: 'CEO & Founder Fitingo',
  },
  {
    id: 2,
    image: slide2,
    quote:
      'GamesBoost42 provided us with the necessary funds for marketing, enhancing our marketing leverage and enabling faster growth of our user base.',
    author: 'Stanislav Levykin',
    position: 'CEO of Gig Partners Inc.',
  },
];

const Slider: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={s.sliderContainer}>
      <div className={s.logo}>
        <Logo />
      </div>

      <div className={s.slidesWrapper}>
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`${s.slide} ${index === currentSlide ? s.active : ''} ${index === 1 ? s.secondSlide : ''}`}
            style={{
              backgroundImage: `url(${slide.image})`,
            }}
          >
            <div className={s.testimonial}>
              <Flex className={s.quoteContainer} gap="16px" direction="column">
                <Flex gap="4px">
                  <div>« </div>
                  <div className={s.quote}>{slide.quote} »</div>
                </Flex>
                <div className={s.author}>
                  <div className={s.authorName}>{slide.author}</div>
                  <div className={s.authorPosition}>{slide.position}</div>
                </div>
              </Flex>
            </div>
          </div>
        ))}
      </div>

      <div className={s.dots}>
        {slides.map((_, index) => (
          <button
            key={index}
            className={`${s.dot} ${index === currentSlide ? s.activeDot : ''}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Slider;
